import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { trackEvent } from "../utils/analytics";

export default function Success() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const sessionId = params.get("session_id");
  const amount = params.get("amount");

  useEffect(() => {
    console.log("✅ Stripe session_id:", sessionId);
    trackEvent("topup_completed", {
      value: Number(amount || 0),
      currency: "AUD",
      has_session_id: Boolean(sessionId)
    });

    // Optionally verify the payment with backend:
    // secureFetch(`${API_BASE}/checkout-session?session_id=${sessionId}`)

    const timer = setTimeout(() => {
      navigate(`${process.env.REACT_APP_BASENAME || ''}/player`);
    }, 3000);

    return () => clearTimeout(timer);
  }, [amount, navigate, sessionId]);

  return (
    <div className="p-6 text-center">
      <h2 className="text-2xl font-bold text-green-700 mb-2">✅ Top-up Complete!</h2>
      <p className="text-lg mb-2">
        Your wallet has been credited with <strong>${amount}</strong>.
      </p>
      <p>Redirecting to your dashboard...</p>
    </div>
  );
}
